// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2429":"a13f2872","7299":"9459dadb"}[chunkId] + ".chunk.css";
};